import { connect } from 'react-redux';

import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { selectSpaceInfo } from '../../app/selectors/SpaceInfoSelectors';
import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { ChannelTypes } from '../types/ChannelTypes';
import { Channel, ChannelOwnProps, ChannelProps } from './Channel';

export const ConnectedRecommendationsChannel = connect((state: AppState, props: ChannelOwnProps) => {
  const siteUrls = siteUrlsSelector(state);

  let list: IContentInfo[] = [];
  state.home.recommendations.items.forEach((contentId: string) => {
    list.push(state.home.contentById[contentId]);
  });

  const recommendationChannelProps: ChannelProps = {
    channelType: ChannelTypes.recommendations,
    title: Messages.home_recommendationsTitle(),
    seeAllUrl: siteUrls.recommendationListUrl(),
    seeAllAltText: Messages.home_recommendations_alt_seeAll(),
    list,
    isFetching: state.home.recommendations.isFetching,
    numRows: 1,
    maxCardsPerRow: props.maxCardsPerRow,
    spaceInfo: selectSpaceInfo(state)
  };
  return recommendationChannelProps;
})(Channel);
